import React, { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";
import { List, ListItem, ListItemText, Paper, Typography, Box, Chip } from "@mui/material";

const DuplicateList = ({ selfId, value, apiEndpoint, displayPrimary, displaySecondary, disabled }) => {
    const [duplicates, setDuplicates] = useState([]);
    useEffect(() => {
        if (!value || disabled) return setDuplicates([]);
        const timeout = setTimeout(async () => {
            const res = await axiosInstance.get(apiEndpoint, { params: { value, selfId, } });
            setDuplicates(res.data || []);
        }, 300);
        return () => clearTimeout(timeout);
    }, [value, apiEndpoint, disabled, selfId]);

    if (duplicates.length === 0) return null;

    return (
        <Paper
            elevation={2}
            sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                zIndex: 10,
                maxHeight: 200,
                overflowY: "auto",
                p: 2
            }}
        >
            <Typography variant="body2" color="error">
                重複チェック
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                {duplicates.map((item, index) => (
                    <Chip
                        key={index}
                        label={
                            displaySecondary && item[displaySecondary]
                                ? `${item[displayPrimary]} / ${item[displaySecondary]}`
                                : item[displayPrimary]
                        }
                        variant="outlined"
                        color="error"
                        size="small"
                    />
                ))}
            </Box>
        </Paper>
    );
};

export default DuplicateList;
